import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { UserService } from '../../core/user.service';
import { MapInteractionService } from '../../core/map-interaction.service';
import { BgtService } from '../../core/bgt.service';
import saveAs from 'file-saver';
import { UserStore } from '../../core/stores/user.store';
import { pluck } from 'rxjs/operators';
import { GoogleAnalyticsService } from '../../core/google-analytics.service';
import { MatIcon } from '@angular/material/icon';
import { MatFormField, MatLabel, MatInput } from '@angular/material/input';
import { MatSelect, MatOption } from '@angular/material/select';
import { FormsModule } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { AsyncPipe } from '@angular/common';
@Component({
    selector: 'download-request-dialog-component',
    templateUrl: 'download-request-dialog.html',
    styleUrls: ['./download-request-dialog.scss'],
    imports: [MatIcon, MatFormField, MatSelect, MatOption, MatLabel, MatInput, FormsModule, MatButton, RouterLink, AsyncPipe]
})
export class DownloadRequestDialog {
  public selectedOption = 'dwg';
  public emailAddress: string;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DownloadRequestDialog>,
    public userService: UserService,
    private userStore: UserStore,
    private mapInteractionService: MapInteractionService,
    private snackbar: MatSnackBar,
    private bgtService: BgtService,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {}

  public userCredits$ = this.userStore.currentUser$.pipe(pluck('credits'));
  public userName$ = this.userStore.currentUser$.pipe(pluck('email'));

  ngOnInit() {
    this.emailAddress = this.userStore.currentUser$.getValue().email;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  closeInfocard() {
    this.dialogRef.close();
  }

  download() {
    this.closeInfocard();
    this.snackbar.open('Uw download wordt voorbereid. Een moment geduld alstublieft.');
    this.googleAnalyticsService.event('download', {
      currency: 'EUR',
      value: 3,
      fileType: this.selectedOption,
    });
    this.bgtService
      .downloadFeatures(this.mapInteractionService.mapForStatistics.getBounds(), this.selectedOption, this.emailAddress)
      .then((returnedData) => {
        this.userStore.useCredit();
        this.snackbar.open(`De downloadlink wordt verzonden naar ${this.emailAddress}.`, 'OK');
      });
  }
}
